import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { ITableColumnHeader } from "src/app/models/table-column-header";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { BookingDetailsComponent } from "src/app/shared/components/booking-details/booking-details.component";
import { CancelBookingNotesModalComponent } from "src/app/shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { CustomerBookingDetailsComponent } from "src/app/shared/components/customer-booking-details/customer-booking-details.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { AttendanceMarkerComponent } from "../../new-v2-component/attendance-marker/attendance-marker.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";
import { BookingDetailsForMemberComponent } from "src/app/shared/components/booking-details-for-member/booking-details-for-member.component";
import { AssignJobComponent } from "src/app/shared/components/assign-job/assign-job.component";
import { CustomiseBookingComponent } from "src/app/shared/components/customise-booking/customise-booking.component";
import { ManageBookingComponent } from "src/app/shared/components/manage-booking/manage-booking.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { AssignJobForMembersComponent } from "src/app/shared/components/assign-job-for-members/assign-job-for-members.component";
import { AuthService } from "src/app/providers/auth.service";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "sm-all-today-bookings",
  templateUrl: "./all-today-bookings.component.html",
  styleUrls: ["./all-today-bookings.component.scss"],
})
export class AllTodayBookingsComponent implements OnInit, OnDestroy {
  loader: boolean = false;
  pageNo: number = 1;
  apisub: Subscription;
  todaysBookingData: any = [];
  discountInfo: any = null;
  constructor(
    private navservice: NavigationService,
    private loaderservice: LoaderServiceService,
    private _apiservice: ApiService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private _modelRef: MatDialog,
    private _snackBar: MatSnackBar,
    private notificationService: NotificationService
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForMemberAttendance();
    this.listenForMemberBookingStatusUpdate();
    this.listenForBookingAssignmentUpdates();
    this.listenForMemberBookingAssignmentUpdates();
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this._apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_TODAY_BOOKINGS_FOR_DASHBOARD
      ) {
        this.todaysBookingData = [];
        if (resdata.result) {
          resdata.result.forEach((element: any) => {
            if (element.data_type == 1) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "Shop service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (
                element.appointment_status == 0 ||
                element.appointment_status == 1 ||
                element.appointment_status == 2
              ) {
                element.bookingStat = "New";
              } else if (element.appointment_status == 3) {
                element.bookingStat = "In-progress";
              } else if (element.appointment_status == 4) {
                element.bookingStat = "Completed";
              } else if (element.appointment_status == 5) {
                element.bookingStat = "Confirmed";
              } else if (element.appointment_status == 6) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 7) {
                element.bookingStat = "Assigned";
              } else if (element.appointment_status == 8) {
                element.bookingStat = "Cancelled";
              } else if (element.appointment_status == 9) {
                element.bookingStat = "In-progress";
              } else {
                element.bookingStat = "--";
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }

              if (
                !element.employee_name ||
                element.employee_name == "" ||
                element.employee_name == "null"
              ) {
                element.employee_name = "---";
              }

              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                (element.booking_start_time ?? "") +
                " - " +
                (element.booking_end_time ?? "");

              if (element.booking_address) {
                element.booking_address =
                  typeof element.booking_address == "string"
                    ? JSON.parse(element.booking_address)
                    : element.booking_address;
                element.business_address = `Visit: ${element.booking_address.address_line}`;
              }

              this.todaysBookingData.push(element);
            } else if (element.data_type == 2) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "In-premise service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }

              if (element.appointment_status == 0) {
                element.bookingStat = "Absent";
              } else {
                if (element.session_status == 1) {
                  element.bookingStat = "Assigned";
                } else if (element.session_status == 2) {
                  element.bookingStat = "In-progress";
                } else if (element.session_status == 3) {
                  element.bookingStat = "Completed";
                } else if (element.appointment_status == 1) {
                  element.bookingStat = "Present";
                } else {
                  element.bookingStat = "Membership";
                }
              }

              if (
                element.booking_start_time &&
                element.booking_start_time != null
              ) {
                element.booking_start_time = element.booking_start_time.slice(
                  0,
                  5
                );
              }
              if (
                element.booking_end_time &&
                element.booking_end_time != null
              ) {
                element.booking_end_time = element.booking_end_time.slice(0, 5);
              }
              element.employee_name = element.employee_name
                ? element.employee_name
                : "---";

              if (
                element.session_start_time &&
                element.session_start_time != null
              ) {
                element.booking_start_time = element.session_start_time.slice(
                  0,
                  5
                );
              }
              if (
                element.session_end_time &&
                element.session_end_time != null
              ) {
                element.booking_end_time = element.session_end_time.slice(0, 5);
              }
              element.phone =
                element.country_code + " " + element.customer_phone;
              element.time =
                (element.booking_start_time ?? "") +
                " - " +
                (element.booking_end_time ?? "");

              if (element.serviceInfo) {
                if (element.serviceInfo != null) {
                  element.serviceInfo =
                    typeof element.serviceInfo == "string"
                      ? JSON.parse(element.serviceInfo)
                      : element.serviceInfo;
                  element.servicesArray = [];
                  element.serviceInfo.forEach((item: any) => {
                    element.servicesArray.push(" " + item.service_name);
                  });
                }
              }
              if (element.custom_items) {
                if (element.custom_items != null) {
                  element.custom_items =
                    typeof element.custom_items == "string"
                      ? JSON.parse(element.custom_items)
                      : element.custom_items;
                  element.customItemsArray = [];
                  element.custom_items.forEach((item: any) => {
                    element.customItemsArray.push(" " + item.item_name);
                  });
                }
              }
              if (element.appointment_products) {
                if (element.appointment_products != null) {
                  element.appointment_products =
                    typeof element.appointment_products == "string"
                      ? JSON.parse(element.appointment_products)
                      : element.appointment_products;
                  // element.customItemsArray = []
                  // element.serviceInfo.forEach((item:any) => {
                  //   element.customItemsArray.push(' ' + item.item_name)
                  // });
                }
              }

              if (element.booking_type == 0 && (element.booking_address && element.booking_address != '' && element.booking_address != 'null')) {
                element.business_address = `Visit: ${element.booking_address}`;
              }else if(element.booking_type == 0 && (!element.booking_address || element.booking_address == '' || element.booking_address == 'null')){
                element.business_address = 'No address info';
              }

              this.todaysBookingData.push(element);
            } else if (element.data_type == 3) {
              if (element.booking_type == 0) {
                element.bookingType = "Home service";
              } else if (element.booking_type == 1) {
                element.bookingType = "In-premise service";
              } else if (element.booking_type == 2) {
                element.bookingType = "Virtual service";
              }
              element.phone =
                element.country_code + " " + element.customer_phone;

              if (element.appointment_status == 1) {
                element.bookingStat = "New query";
              } else if (element.appointment_status == 2) {
                element.bookingStat = "Query in progress";
              } else if (element.appointment_status == 3) {
                element.bookingStat = "Marked enrolled";
              } else if (element.appointment_status == 4) {
                element.bookingStat = "Query cancelled";
              } else if (element.appointment_status == 5) {
                element.bookingStat = "Query enrolled";
              }
              element.employee_name = "---";
              if (element.enrolled_member_timings) {
                element.enrolled_member_timings =
                  typeof element.enrolled_member_timings == "string"
                    ? JSON.parse(element.enrolled_member_timings)
                    : element.enrolled_member_timings;
              }
              element.time = element.enrolled_member_timings
                ? this.formatSchedule(element.enrolled_member_timings)
                : "---";
              this.todaysBookingData.push(element);
            }
          });
        }
        console.log(this.todaysBookingData);

        this.loaderservice.showLoader = false;
        this.loader = false;
      }

      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resdata.result) {
          this.discountInfo = resdata.result;
        }
        this.loaderservice.showLoader = false;
        if (this.o_type == "done") {
          let data = this.c_data;
          data.discountInfo = this.discountInfo;
          this._modelRef.open(ManageBookingComponent, {
            width: "700px",
            data: {
              title: "Manage Booking",
              ref: this._modelRef,
              data: data,
            },
          });
          this.o_type = this.c_data = null;
        }
        if (this.o_type == "customise") {
          let data = this.c_data;
          data.discountInfo = this.discountInfo;

          this._modelRef.open(CustomiseBookingComponent, {
            width: "700px",
            data: {
              title: "Edit Booking Operation",
              ref: this._modelRef,
              data: data,
            },
          });
          this.o_type = this.c_data = null;
        }
      }

      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_MARK_MEMBER_ATTENDANCE_STATUS
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_RESET_BOOKING_DETAILS
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType === SM_CONSTANTS.RESULT_API_UPDATE_MEMBER_SESSION
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_ASSIGN_EMPLOYEE_TO_MEMBER
      ) {
        this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
      }
    });
  }

  ngOnInit(): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
      queryParamsHandling: "", // Clears all other params
      replaceUrl: true,
    });
    this.loaderservice.showLoader = true;
    this.loader = true;
    this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }

  private memberattendancesubscription: Subscription = new Subscription();
  listenForMemberAttendance() {
    this.memberattendancesubscription = this.notificationService
      .getNotificationByType("onMemberAttendance")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }
  private memberbookingstatuschangedsubscription: Subscription =
    new Subscription();
  listenForMemberBookingStatusUpdate() {
    this.memberbookingstatuschangedsubscription = this.notificationService
      .getNotificationByType("memberBookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }
  private memberBookingAssignmentsubscription: Subscription =
    new Subscription();
  listenForMemberBookingAssignmentUpdates() {
    this.memberBookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onMemberAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          payload.data.misc =
            typeof payload.data.misc == "string"
              ? JSON.parse(payload.data.misc)
              : payload.data.misc;
          if (true) {
            this._apiservice.getTodaysBookingsForDashboard("500", this.pageNo);

            // snackBarRef.afterDismissed().subscribe(() => {
            //   console.log('Snackbar dismissed');
            // });

            // snackBarRef.onAction().subscribe(() => {
            //   console.log('Snackbar action triggered');
            // });
          }
        }
      });
  }

  // tableDisplayColumns: string[] = ['image', 'name', 'shop', 'payment', 'time', 'assigned', 'status'];

  bookingData = [
    {
      image:
        "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "10:55 - 12:00",
      service: "Shop",
      starus: "In-progress",
    },
    {
      image:
        "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
      name: "Suraj Paul",
      phone: "+91 8989835354",
      shop: "Evonie Hair Salon & Makeup Studio",
      location:
        "2nd floor, Raj sammilonee MAX mall, Bhiringi, Benachity, Durgapur, West Bengal 713213",
      time: "10:55 - 12:00",
      service: "Home",
      starus: "In-progress",
    },
    {
      image:
        "https://media.istockphoto.com/id/1136413215/photo/young-man-at-street-market.jpg?s=612x612&w=0&k=20&c=obnaR5III0jRxHKd4ZPl3LRC2pI792KbHYR2eBzKKe8=",
      name: "Sourav Das",
      phone: "+91 8989835354",
      shop: "Invogue Salon Spa & NailBar",
      location:
        "2nd Floor, Kamdhenu, Bengal Shrishti, above HDFC Bank, Durgapur, West Bengal 713216",
      time: "10:55 - 12:00",
      service: "Shop",
      starus: "Completed",
    },
    {
      image:
        "https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://fdczvxmwwjwpwbeeqcth.supabase.co/storage/v1/object/public/images/8f706226-0b67-41ea-b84e-a7add4ea0658/fadf9214-bad0-41cb-8318-272d81dfe466.png",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "11:55 - 1:00",
      service: "Home",
      starus: "In-progress",
    },
    {
      image:
        "https://www.shutterstock.com/image-photo/cheerful-black-man-wearing-leather-600nw-2238222273.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "12:55 - 2:00",
      service: "Home",
      starus: "Completed",
    },
    {
      image:
        "https://media.istockphoto.com/id/613557584/photo/portrait-of-a-beautifull-smiling-man.jpg?s=612x612&w=0&k=20&c=hkCg5CrmTKOApePbPOyo1U9GexEfIJOJqoLXJIvcN8E=",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "10:55 - 4:00",
      service: "Home",
      starus: "In-progress",
    },
    {
      image:
        "https://t4.ftcdn.net/jpg/02/70/84/61/360_F_270846119_LKNW0GcldOoicB0D4jKChIqClQl2Bd2N.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "12:55 - 12:00",
      service: "Shop",
      starus: "In-progress",
    },
    {
      image:
        "https://t4.ftcdn.net/jpg/01/34/51/81/360_F_134518160_5DyP0y6YqXQgG6FdorIvpk7M6CBNrglm.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "10:55 - 12:00",
      service: "Home",
      starus: "Completed",
    },
    {
      image:
        "https://images.rawpixel.com/image_800/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDIzLTA4L3Jhd3BpeGVsX29mZmljZV8yX3Bob3RvX29mX2FfYmxhY2tfYnVzaW5lc3NtYW5faXNvbGF0ZWRfb25fb2ZmX19lZmMxZDllNC1iNzQ5LTQ2NzMtYjRmMS1lYjI0NTBiYzNiOGRfMS5qcGc.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "10:55 - 12:00",
      service: "Home",
      starus: "Completed",
    },
    {
      image:
        "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg",
      name: "Rahul raj Rathod",
      phone: "+91 8989835354",
      shop: "Mithali Hair, Spa, Balanced Beauty",
      location:
        "Kali Bari, UCP 26, near Ambuja, Bengal Ambuja Durgapur, West Bengal 713216",
      time: "10:55 - 12:00",
      service: "Shop",
      starus: "Completed",
    },
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "name",
      columnProperty: "customer_name",
    },
    {
      columnName: "phone",
      columnProperty: "phone",
    },
    {
      columnName: "shop",
      columnProperty: "business_name",
    },
    {
      columnName: "location",
      columnProperty: "business_address",
    },
    {
      columnName: "time",
      columnProperty: "time",
    },
    {
      columnName: "service",
      columnProperty: "bookingType",
    },
    {
      columnName: "assigned to",
      columnProperty: "employee_name",
    },

    {
      columnName: "status",
      columnProperty: "bookingStat",
    },
  ];

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
    if (this.memberattendancesubscription) {
      this.memberattendancesubscription.unsubscribe();
    }
    if (this.memberbookingstatuschangedsubscription) {
      this.memberbookingstatuschangedsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.memberBookingAssignmentsubscription) {
      this.memberBookingAssignmentsubscription.unsubscribe();
    }
  }

  deleteBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.booking_hash,
          entityHash: item.business_hash,
        };

        this.loaderservice.showLoader = true;
        this._apiservice.deleteEntityAppointmentData(obj);
      }
    });
  }

  bookingDetails(item: any) {
    console.log(item);

    this.authService.setUserRole(item.is_owner == 1 ? "owner" : "employee");
    localStorage.setItem(
      SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
      item.employee_hash_id
    );
    localStorage.setItem(
      SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
      item.entity_public_hash_id
    );

    if (item.data_type == 1) {
      this.router.navigate(["booking-details"], {
        relativeTo: this.route,
        queryParams: {
          bookingHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id,
        },
      });
    } else if (item.data_type == 2) {
      this.router.navigate(["membership-booking-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          memberHash: item.member_hash,
          isf: "0",
          entityHash: item.business_hash,
          bd: item.booking_date,
        },
      });
    } else if (item.data_type == 3) {
      this.router.navigate(["query-details"], {
        relativeTo: this.route,
        queryParamsHandling: "merge",
        queryParams: {
          queryHash: item.booking_hash,
          entityHash: item.business_hash,
          eph: item.entity_public_hash_id,
        },
      });
    }
  }

  confirmBooking(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: item.employee_hash_id,
        assignedByHash: item.employee_hash_id,
        appointmentHash: item.booking_hash,
        bookingStatus: 5,
        startTime: item.booking_start_time.slice(0, 5),
        endTime: item.booking_end_time.slice(0, 5),
        entityHash: item.business_hash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.booking_price,
        bookingDate: item.booking_date,
        note: item.booking_note,
        bookingType: item.booking_type,
        customerHash: item.customer_hash,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this._apiservice.updateBookingStatus(data);
  }

  cancelBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this._modelRef.open(
          CancelBookingNotesModalComponent,
          {
            width: "600px",
            data: {
              title: "Cancel Booking",
            },
          }
        );
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: item.employee_hash_id,
                assignedByHash: item.employee_hash_id,
                appointmentHash: item.booking_hash,
                startTime: item.booking_start_time.slice(0, 5),
                endTime: item.booking_end_time.slice(0, 5),
                entityHash: item.business_hash,
                countryCode: item.country_code,
                customerPh: item.customer_phone,
                customerName: item.customer_name,
                price: item.booking_price,
                bookingDate: item.booking_date,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.booking_type,
                customerHash: item.customer_hash,
              },
            };

            console.log(data);
            this.loaderservice.showLoader = true;
            this._apiservice.updateBookingStatus(data);
          }
        });
      }
    });
  }

  openInvoice(item: any) {
    localStorage.setItem(
      SM_CONSTANTS.IS_ENTITY_FOREIGN,
      item.currency == "INR" ? "0" : "1"
    );
    this._modelRef.open(InvoiceComponent, {
      width: "510px",
      data: {
        title: "Invoice",
        ref: this._modelRef,
        showmerge: 1,
        data: item.booking_hash,
      },
    });
  }

  changeAttendanceStatus(status: any, item: any) {
    let msg = "";
    if (status == 0) {
      msg = "Are you sure you want to mark this appointment as absent?";
    } else if (status == 1) {
      msg = "Are you sure you want to mark this appointment as present?";
    }
    const dialogRef = this._modelRef.open(AttendanceMarkerComponent, {
      data: {
        title: "Alert",
        status: status,
        message: msg,
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          hash_id: item.booking_hash, // only while updating the attendance status
          entity_hash: item.business_hash,
          member_hash: item.member_hash,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          attendance_status: status, //0-absent,1-present
          notes: result.note,
          attendance_date: this.formatDateForApi(new Date()),
        };

        Object.keys(data).forEach((key) => {
          if ((data as any)[key] === null) {
            delete (data as any)[key];
          }
        });

        console.log(data);

        this.loaderservice.showLoader = true;
        this._apiservice.markMemberAttendanceStatus(data);
      }
    });
  }
  formatDateForApi(dateStr: Date) {
    // let curdate = new Date().toISOString().slice(0,10);
    // return curdate;

    let curdate = dateStr
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;

    // // Split the date string by `/`
    // const parts = dateStr.split('/');

    // // Reverse the order of the parts and join them with `-`
    // const newDateStr = parts.reverse().join('-');

    // // Return the formatted date string
    // return newDateStr;
  }

  deleteAttendance(rowvalue: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      width: "400px",
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this member's attendance?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          entityHash: rowvalue.business_hash,
          memberHash: rowvalue.member_hash,
          attendanceHash: rowvalue.booking_hash,
        };

        console.log(data);
        this.loaderservice.showLoader = true;
        this._apiservice.deleteMemberAttendanceDataByEntity(data);
      }
    });
  }

  viewDetailsForMember(item: any) {
    this._modelRef.open(BookingDetailsForMemberComponent, {
      width: "600px",
      disableClose: true,
      data: {
        data: item,
      },
    });
  }

  startProcess(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: item.employee_hash_id,
        assignedByHash: item.employee_hash_id,
        appointmentHash: item.booking_hash,
        bookingStatus: 3,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHour(this.formatTimeForTime(new Date())),
        entityHash: item.business_hash,
        countryCode: item.country_code,
        customerPh: item.customer_phone,
        customerName: item.customer_name,
        price: item.booking_price,
        bookingDate: item.booking_date,
        note: item.booking_note,
        bookingType: item.booking_type,
        customerHash: item.customer_hash,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this._apiservice.updateBookingStatus(data);
  }

  assignJob(item: any) {
    this._modelRef.open(AssignJobComponent, {
      width: "800px",
      data: {
        title: "Assign job",
        ref: this._modelRef,
        data: this.normalizeAppointmentData(item),
      },
    });
  }

  reset(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      maxWidth: "700px",
      data: {
        title: "Alert",
        message:
          "This will remove all the operation data like booked services, completed services status, employee engagement, etc. The appointment status will become NEW once again. Are you sure you want to continue?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let data = {
          appointmentHashId: item.booking_hash,
        };
        this.loaderservice.showLoader = true;
        this._apiservice.resetBookingDetails(data);
      }
    });
  }

  o_type: any;
  c_data: any;
  done(item: any) {
    this.o_type = "done";
    this.c_data = {
      entityHash: item.business_hash,
      eph: item.entity_public_hash_id,
      serviceType: item.booking_type,
      bookingData: this.normalizeAppointmentData(item),
      discountInfo: this.discountInfo,
    };
    this.loaderservice.showLoader = true;
    this._apiservice.getBillDiscountData(item.entity_public_hash_id);
  }

  customiseBooking(item: any) {
    this.o_type = "customise";
    this.c_data = {
      entityHash: item.business_hash,
      eph: item.entity_public_hash_id,
      serviceType: item.booking_type,
      bookingData: this.normalizeAppointmentData(item),
      discountInfo: this.discountInfo,
    };
    this.loaderservice.showLoader = true;
    this._apiservice.getBillDiscountData(item.entity_public_hash_id);
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  formatTimeforquery(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  // NORMALISER
  normalizeAppointmentData(raw: any): any {
    const parsedServiceInfo =
      typeof raw.serviceInfo === "string"
        ? JSON.parse(raw.serviceInfo)
        : raw.serviceInfo;
    const parsedCustomItems =
      typeof raw.custom_items === "string"
        ? JSON.parse(raw.custom_items)
        : raw.custom_items;
    const parsedAppointmentProducts =
      typeof raw.appointment_products === "string"
        ? JSON.parse(raw.appointment_products)
        : raw.appointment_products;

    return {
      hash_id: raw.booking_hash || raw.hash_id,
      appointment_no: raw.appointment_no,
      creationDate: raw.creation_date || raw.creationDate,
      bookingDate: raw.booking_date || raw.bookingDate,
      bookingType: raw.booking_type || raw.bookingType,
      price: raw.booking_price || raw.price,
      paymentStatus: raw.paymentStatus,
      paymentMode: raw.payment_mode || raw.paymentMode,
      customerPayment: raw.customer_payment || 0,
      note: raw.booking_note || raw.note,
      currency_symbol: raw.currency_symbol,
      currency: raw.currency,
      country_code: raw.country_code,
      payment_due: raw.payment_due || 0,
      cancellationNotes: raw.cancellationNotes || null,
      employeeName: raw.employee_name || raw.employeeName,
      custom_items: parsedCustomItems || null,
      modifiedBy: raw.member_hash || raw.modifiedBy,
      bookingStatus: raw.appointment_status || raw.bookingStatus,
      bookingStartTime: raw.booking_start_time || raw.bookingStartTime,
      bookingEndTime: raw.booking_end_time || raw.bookingEndTime,
      updateStatusDate: raw.creation_date || raw.updateStatusDate,
      entityHash: raw.business_hash || raw.entityHash,
      customer_name: raw.customer_name || raw.cust_name || "",
      customer_phone: raw.customer_phone || raw.phone || raw.cust_phn,
      customerInfo: {
        name: raw.customer_name || "",
        phone: raw.customer_phone || "",
        imgUrl: raw.customer_image || null,
        imgThumbUrl: raw.customer_thumb_image || null,
        gender: raw.gender || null,
        addressLine: null,
        country: raw.country || null,
        city: null,
        state: null,
        zip: null,
        hash_id: raw.customer_hash || null,
        profile_hash: null,
      },
      entityInfo: {
        zip: null,
        city: null,
        state: null,
        country: null,
        hash_id: raw.business_hash || raw.entityHash,
        entityName: raw.business_name || "",
        addressLine: raw.business_address || "",
        entityPhone: null,
        todayHomeSales: 0,
        todayShopSales: 0,
      },
      serviceInfo: parsedServiceInfo || [],
      appointment_products: parsedAppointmentProducts || null,
      customerName: raw.customer_name || "",
      customerPhone: raw.phone || raw.customer_phone,
      servicesArray: parsedServiceInfo
        ? parsedServiceInfo.map((s: any) => s.serviceName)
        : [],
      costing: `${raw.currency_symbol || ""}${
        raw.booking_price || raw.price || 0
      }`,
      cust_name: raw.customer_name || "",
      cust_phn: `${raw.country_code || ""} ${raw.customer_phone || ""}`,
      paymentStat:
        (raw.payment_due || raw.customer_payment || 0) > 0 ? "Due" : "Paid",
      bookingStat: raw.bookingStat || "Booking confirmed",
    };
  }

  normalizeMmembershipData(raw: any): any {
    return {
      gender: raw.gender || null,
      billing_cycle: raw.billing_cycle || null,
      member_notes: raw.member_notes || null,
      member_thumb_image: raw.member_thumb_image || null,
      bookingDate: raw.booking_date || null,
      hash_id: raw.booking_hash || null,
      member_hash_id: raw.member_hash || null,
      appointment_no: raw.appointment_no || null,
      creationDate: raw.creation_date || null,
      bookingType: raw.booking_type || null,
      price: raw.booking_price || 0,
      paymentStatus: raw.paymentStatus ?? null,
      paymentMode: raw.payment_mode || null,
      payment_due: raw.payment_due ?? 0,
      customerPayment: raw.customer_payment ?? null,
      note: raw.booking_note || null,
      currency_symbol: raw.currency_symbol || "$",
      currency: raw.currency || "USD",
      country_code: raw.country_code || "+1",
      cancellationNotes: null,
      employeeName: raw.employee_name || null,
      custom_items:
        typeof raw.custom_items === "string"
          ? JSON.parse(raw.custom_items)
          : raw.custom_items || null,
      modifiedBy: null,
      bookingStatus: raw.appointment_status || null,
      bookingStartTime: raw.booking_start_time || null,
      bookingEndTime: raw.booking_end_time || null,
      updateStatusDate: null,
      entityHash: raw.business_hash || null,
      customer_name: raw.customer_name || null,
      customer_phone: raw.customer_phone || null,
      customerInfo: {
        name: raw.customer_name || null,
        phone: raw.customer_phone || null,
        imgUrl: raw.customer_image || null,
        imgThumbUrl: raw.customer_thumb_image || null,
        gender: raw.gender || null,
        hash_id: raw.customer_hash || null,
        addressLine: raw.business_address || null,
        city: null,
        zip: null,
        state: null,
        country: null,
        profile_hash: null,
      },
      entityInfo: {
        entityName: raw.business_name || null,
        addressLine: raw.business_address || null,
        entityPhone: raw.customer_phone || null,
        city: null,
        state: null,
        country: null,
        zip: null,
        hash_id: raw.business_hash || null,
      },
      serviceInfo:
        typeof raw.serviceInfo === "string"
          ? JSON.parse(raw.serviceInfo)
          : raw.serviceInfo || [],
      appointment_products:
        typeof raw.appointment_products === "string"
          ? JSON.parse(raw.appointment_products)
          : raw.appointment_products || null,
      session_status: raw.session_status || null,
      session_start_time: raw.session_start_time || null,
      session_end_time: raw.session_end_time || null,
      enrolled_member_timings:
        typeof raw.enrolled_member_timings === "string"
          ? JSON.parse(raw.enrolled_member_timings)
          : raw.enrolled_member_timings || [],
      data_type: raw.data_type || null,
    };
  }

  operationForMember(item: any, status: any) {
    this.loaderservice.showLoader = true;
    if (status == 2) {
      let obj = {
        memberHash: item.member_hash,
        entityHash: item.business_hash,
        employeeHash: item.employee_hash_id,
        assignByHash: item.employee_hash_id,
        sessionStatus: status,
        startTime: this.formatTimeForTime(new Date()),
        endTime: this.addOneHour(this.formatTimeForTime(new Date())),
        attendanceHash: item.booking_hash,
      };

      this._apiservice.UpdateMemberSession(obj);
    }
    if (status == 3) {
      let obj = {
        memberHash: item.member_hash,
        entityHash: item.business_hash,
        employeeHash: item.employee_hash_id,
        assignByHash: item.employee_hash_id,
        sessionStatus: status,
        startTime: item.booking_start_time.slice(0, 5),
        endTime: this.formatTimeForTime(new Date()),
        attendanceHash: item.booking_hash,
      };

      this._apiservice.UpdateMemberSession(obj);
    }
  }

  assignJobForMember(item: any) {
    this._modelRef.open(AssignJobForMembersComponent, {
      width: "800px",
      data: {
        title: "Assign job",
        ref: this._modelRef,
        data: this.normalizeMmembershipData(item),
      },
    });
  }

  formatTimeForTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }
  addOneHour(timeStr: any) {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);

    // Add one hour
    date.setHours(date.getHours() + 1);

    // Format back to HH:mm
    const newHours = String(date.getHours()).padStart(2, "0");
    const newMinutes = String(date.getMinutes()).padStart(2, "0");

    return `${newHours}:${newMinutes}`;
  }

  // NEW CODE FOR ROW CLICK
  rowClickHandler = (row: any) => {
    this.bookingDetails(row);
  };

  formatSchedule(schedule: any[]): string {
    return schedule
      .map((item) => {
        const weekday = this.getWeekdayString(item.weekday);
        const startTime = this.formatTimeforquery(item.start_time);
        const endTime = this.formatTimeforquery(item.end_time);
        return `${weekday}: ${startTime} - ${endTime}`;
      })
      .join(", ");
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }
}
